// Mirrors constants/billingNote.ts on the API -- no VOID status here either: every note is
// created already ISSUED (exclusive to already-"ready" data), a mistaken one is countered by an
// opposite note, never edited.
export const BILLING_NOTE_STATUSES = ["ISSUED", "FULLY_APPLIED"];

export const BILLING_NOTE_STATUS_COLORS = {
  ISSUED: "blue",
  FULLY_APPLIED: "green",
};

export const CREDIT_NOTE_REASONS = [
  "GOODWILL",
  "DISPUTE_RESOLUTION",
  "SERVICE_FAILURE",
  "STATUS_CORRECTION",
  "OTHER",
];

export const DEBIT_NOTE_REASONS = ["WEIGHT_DISPUTE_CORRECTION", "MANUAL", "OTHER"];

export const BILLING_NOTE_REASON_LABELS = {
  GOODWILL: "Goodwill",
  DISPUTE_RESOLUTION: "Dispute Resolution",
  SERVICE_FAILURE: "Service Failure",
  STATUS_CORRECTION: "Status Correction",
  WEIGHT_DISPUTE_CORRECTION: "Weight Dispute Correction",
  MANUAL: "Manual",
  OTHER: "Other",
};
